import React from 'react';
import { OrderContactInfo } from '../types';
import { useTranslation } from '../i18n';
import { LocationMap, LatLng } from './LocationMap';

function contactLocationPrecise(contact: OrderContactInfo): LatLng | null {
  if (contact.preciseLatitude == null || contact.preciseLongitude == null) return null;
  return { lat: contact.preciseLatitude, lng: contact.preciseLongitude };
}

export const ContactDetails: React.FC<{
  title: string;
  contact: OrderContactInfo;
  showAddresses: boolean;
}> = ({ title, contact, showAddresses }) => {
  const { t } = useTranslation();

  return (
    <div style={{ marginTop: '0.75rem' }}>
      <p className="order-meta" style={{ fontWeight: 600, marginBottom: '0.5rem' }}>{title}</p>
      <dl style={{ margin: 0, fontSize: '0.9rem', display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '0.25rem 1rem' }}>
        {contact.trueName && (
          <>
            <dt className="text-muted">{t('dashboard.contact.true_name')}</dt>
            <dd style={{ margin: 0 }}>{contact.trueName}</dd>
          </>
        )}
        {contact.email && (
          <>
            <dt className="text-muted">{t('account.email')}</dt>
            <dd style={{ margin: 0 }}><a href={`mailto:${contact.email}`}>{contact.email}</a></dd>
          </>
        )}
        {contact.phone && (
          <>
            <dt className="text-muted">{t('account.settings_phone_number')}</dt>
            <dd style={{ margin: 0 }}><a href={`tel:${contact.phone}`}>{contact.phone}</a></dd>
          </>
        )}
        {showAddresses && contact.preciseAddress && (
          <>
            <dt className="text-muted">{t('dashboard.contact.precise_address')}</dt>
            <dd style={{ margin: 0 }}>{contact.preciseAddress}</dd>
          </>
        )}
        {showAddresses && contactLocationPrecise(contact) && (
          <>
            <dt className="text-muted">{t('dashboard.contact.location')}</dt>
            <dd style={{ margin: 0, gridColumn: '1 / -1' }}>
              <LocationMap
                precise={contactLocationPrecise(contact)}
                height={260}
              />
            </dd>
          </>
        )}
      </dl>
    </div>
  );
};
